import type React from 'react';

import { FormField, FormHelp, Label, Textarea } from '@zillow/constellation';

import type { Section } from '../../../../models/index';
import { CUSTOM_RULES } from '../../../../constants';
import AdditionalRulesTemplate from './AdditionalRulesTemplate';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

const CHECKED_STATE = {
  [CUSTOM_RULES.FIELD_NAME.IS_ENABLED]: true,
};

const UNCHECKED_STATE = {
  [CUSTOM_RULES.FIELD_NAME.IS_ENABLED]: false,
  [CUSTOM_RULES.FIELD_NAME.CUSTOM_RULES]: '',
};

export default function CustomRules({ section, setSectionValues }: Props): JSX.Element {
  function toggleCustomRules(): void {
    const isEnabled = section.getFieldValue(CUSTOM_RULES.FIELD_NAME.IS_ENABLED);
    const setFields = isEnabled ? UNCHECKED_STATE : CHECKED_STATE;

    setSectionValues({
      ...setFields,
    });
  }

  function onCustomRuleChange(e: React.FormEvent<HTMLInputElement>): void {
    const { value } = e.currentTarget;

    setSectionValues({ [CUSTOM_RULES.FIELD_NAME.CUSTOM_RULES]: value });
  }

  const switchedOn = section.getFieldValue(CUSTOM_RULES.FIELD_NAME.IS_ENABLED);

  return (
    <AdditionalRulesTemplate
      title="Custom rules"
      caption="You can write (or copy and paste) your own rules to include in the lease."
      switchTitle="Include custom rules"
      switchedOn={switchedOn}
      toggleSwitch={toggleCustomRules}
    >
      {switchedOn && (
        <FormField
          label={<Label>Custom rules description</Label>}
          control={
            <Textarea
              aria-label="Custom rule description"
              rows="5"
              resize="vertical"
              onChange={onCustomRuleChange}
              value={section.getFieldValue(CUSTOM_RULES.FIELD_NAME.CUSTOM_RULES)}
            />
          }
          description={
            <FormHelp>
              A custom rule cannot override another part of your lease or add additional legal clauses
            </FormHelp>
          }
        />
      )}
    </AdditionalRulesTemplate>
  );
}
